import axios from 'axios'

export const getFundsCategories = ({ commit }) => {
  commit('setLoading', true);
  axios.get('/api/fundsCategories/fundsCategories')
    .then(response => {
      commit('getFundsCategories', response.data.data)
    })
    // fail
    .catch(e => {
      commit('getFundsCategories', e.response)
    })
    .finally(() => {
      commit('setLoading', false);
    });
}